module.exports = __webpack_public_path__ + "img/search-empty.7c186663.png";